package com.example.mystybag.e5AiSearch.helpers

class E5Embedder(
    private val tokenizer: E5Tokenizer,
    private val runner: PlatformOnnxRunner,
    private val maxLen: Int,
    private val dim: Int
) : Embedder {
    override suspend fun embedQuery(text: String): FloatArray {
        val t = "query: ${normalizeText(text)}"
        return embed(t)
    }

    override suspend fun embedDoc(text: String): FloatArray {
        val t = "passage: ${normalizeText(text)}"
        return embed(t)
    }

    private suspend fun embed(text: String): FloatArray {
        val tokens = tokenizer.encode(text, maxLen)
        val hidden = runner.run(tokens)                 // [maxLen][dim]
        val pooled = meanPool(hidden, tokens.attentionMask, dim)
        return l2Normalize(pooled)
    }
}